import React from 'react';

import { RenderDropdown } from 'forms';
import { Field } from 'react-final-form';
import { useSelector } from 'react-redux';
import { selectOptions } from './selectors';

interface Props {
    name: string;
    validate?: any;
}

export default function ChecklistSchemasDropdown(
    props: Props
): React.ReactElement {
    const { name, validate } = props;

    const options = useSelector(selectOptions);

    return (
        <Field
            component={RenderDropdown as any}
            subscription={{
                value: true,
                touched: true,
                error: true
            }}
            name={name}
            validate={validate}
            label="Checklist type"
            placeholder="Select a checklist"
            fluid
            search
            selection
            clearable
            selectOnBlur={false}
            options={options}
        />
    );
}
